import { useEffect, useRef } from 'react';
import { Subscription } from 'rxjs';

export class Controller {
  subList: Subscription[] = [];
  constructor() {
    this.subList = [];
  }
  init() {}

  destroy() {
    this.subList.forEach((sub) => sub.unsubscribe());
  }
}

export function useController<T extends Controller>(Ctrl: new () => T) {
  const ctrl = useRef<T>(new Ctrl()).current;
  useEffect(() => {
    ctrl.init();
    return () => {
      ctrl.destroy();
    };
  }, []);
  return ctrl;
}
